var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33334 4.66669L6.7766 8.47695C7.2174 8.78555 7.4378 8.93982 7.67754 8.99955C7.88927 9.05235 8.11074 9.05235 8.32247 8.99955C8.5622 8.93982 8.7826 8.78555 9.2234 8.47695L14.6667 4.66669M4.53334 13.3334H11.4667C12.5868 13.3334 13.1468 13.3334 13.5747 13.1154C13.951 12.9236 14.2569 12.6177 14.4487 12.2414C14.6667 11.8135 14.6667 11.2535 14.6667 10.1334V5.86669C14.6667 4.74658 14.6667 4.18653 14.4487 3.75871C14.2569 3.38238 13.951 3.07642 13.5747 2.88467C13.1468 2.66669 12.5868 2.66669 11.4667 2.66669H4.53334C3.41323 2.66669 2.85318 2.66669 2.42536 2.88467C2.04903 3.07642 1.74307 3.38238 1.55132 3.75871C1.33334 4.18653 1.33334 4.74658 1.33334 5.86669V10.1334C1.33334 11.2535 1.33334 11.8135 1.55132 12.2414C1.74307 12.6177 2.04903 12.9236 2.42536 13.1154C2.85318 13.3334 3.41323 13.3334 4.53334 13.3334Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.d8b13c584e932cfb4c797f53b4d0b94b.svg";
export { ForwardRef as ReactComponent };